import { type Modality } from '@/infra/services/catalog/product/get-shipments/model';
import { getModalityMessage } from '@/utils/catalog/get-modality-message';

export const getDeadlineMessage = (cheapestModality?: Modality) => {
  if (!cheapestModality) {
    return undefined;
  }

  const deadlineMessage = getModalityMessage(cheapestModality);

  if (!deadlineMessage.prefix || !deadlineMessage.main) {
    return undefined;
  }

  return `${deadlineMessage.prefix} ${deadlineMessage.main}`;
};
